<template>
  <v-app>
    <Topbar
        v-if="userLogged && !is_report"
        v-bind:userName="userName"
        v-bind:companyName="'WinGD'"
    />
    <v-content fluid style="background-color:rgb(244,244,244);height:100vh;">
      <Titlebar v-if="userLogged && !is_report"/>
      <router-view/>
    </v-content>
    <OverheadLoader v-if="!is_report"/>
  </v-app>
</template>

<script>
import Topbar from './components/Topbar'
import Titlebar from './components/Titlebar'
import OverheadLoader from "@/components/OverheadLoader";

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';

import {store} from "./main.js"

export default {
  name: 'App',
  components: {
    Topbar,
    Titlebar,
    OverheadLoader
  },
  data() {
    return {}
  },
  created() {
    setTimeout(() => {
      store.logout_msg = localStorage.getItem('wingd_users_logout_msg') || '';
    }, 100)

    if (window.$cookies.isKey('user')) {
      store.userProfile = window.$cookies.get('user');
      store.userLogged = true;

      // this.$router.push({path: 'engines'});
    } else {
      store.userLogged = false;
      window.$cookies.remove('user');
      this.$router.push({path: '/login'});
    }
  },
  mounted() {
    setTimeout(() => {
      this.setStyle();
    }, 10);
  },
  methods: {
    setStyle() {
      if (! this.is_report) {
        let html_element =  document.querySelector('html');
        html_element.style.overflow = 'hidden';
        html_element.style.minHeight = '100vh';
        html_element.style.maxHeight = '100vh';

        let body_element =  document.querySelector('body');
        body_element.style.overflow = 'hidden';
        body_element.style.minHeight = '100vh';
        body_element.style.maxHeight = '100vh';
      }
    }
  },
  computed: {
    userName: function () {
      return store.userProfile.displayName;
    },
    userLogged: function () {
      return store.userLogged;
    },
    is_report: function () {
      return this.$route.path.indexOf('report') > -1
    }
  },
  watch: {

  }
}
</script>

<style>
html, body {
  /*overflow: hidden !important;*/
  /*min-height: 100vh;*/
  /*max-height: 100vh;*/
}
</style>

